import { useEffect, useRef } from 'react';
import { Warning as WarningProps } from '../../interfaces';
import {
  BdsAlert,
  BdsAlertActions,
  BdsAlertBody,
  BdsAlertHeader,
  BdsButton,
  BdsTypo,
} from 'blip-ds/dist/blip-ds-react/components';

export const Warning = ({
  submitText,
  closeText,
  declineText,
  handleSubmitButton,
  handleCloseButton,
  handleDeclineButton,
  loading,
  text,
  title,
  variant,
  isOpen,
  setIsOpen,
}: WarningProps) => {
  const modalRef = useRef<HTMLBdsModalElement | null>(null);
  const variant_icons = { warning: 'warning', delete: 'trash' };

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !((modalRef.current as unknown) as Element).contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <BdsAlert open={isOpen}>
      <BdsAlertHeader variant={variant} icon={variant_icons[variant]}>
        {title}
      </BdsAlertHeader>
      <BdsAlertBody>
        <BdsTypo variant="fs-14">{text as React.ReactNode}</BdsTypo>
      </BdsAlertBody>
      <BdsAlertActions>
        <BdsButton class="button" onClick={loading ? () => {} : handleCloseButton} variant="ghost" disabled={loading}>
          <BdsTypo variant="fs-14" bold="bold">
            {closeText}
          </BdsTypo>
        </BdsButton>
        {declineText && (
          <BdsButton
            onClick={loading ? () => {} : handleDeclineButton}
            variant="secondary"
            class="button"
            disabled={loading}
          >
            {declineText}
          </BdsButton>
        )}
        {submitText && (
          <BdsButton onClick={handleSubmitButton} variant="primary" bdsLoading={loading} class="button">
            {submitText}
          </BdsButton>
        )}
      </BdsAlertActions>
    </BdsAlert>
  );
};
